export const DASHBOARD_ACCESS_CONFIG = {
  enableMenuPermissionValidation: true,
  enableBackendLoginValidation: true,
};

export const DASHBOARD_STORAGE_KEYS = {
  permissions: "permissions",
  token: "token",
  tokenExpire: "tokenExpire",
  user: "user",
  username: "username",
  photo: "photo",
};

export const isMenuPermissionFilterEnabled = () =>
  DASHBOARD_ACCESS_CONFIG.enableMenuPermissionValidation;

export const isBackendLoginValidationEnabled = () =>
  DASHBOARD_ACCESS_CONFIG.enableBackendLoginValidation;

export const clearDashboardSession = () => {
  if (typeof window === "undefined") {
    return;
  }

  sessionStorage.removeItem(DASHBOARD_STORAGE_KEYS.token);
  sessionStorage.removeItem(DASHBOARD_STORAGE_KEYS.tokenExpire);
  localStorage.removeItem(DASHBOARD_STORAGE_KEYS.user);
  localStorage.removeItem(DASHBOARD_STORAGE_KEYS.permissions);
  localStorage.removeItem(DASHBOARD_STORAGE_KEYS.username);
  localStorage.removeItem(DASHBOARD_STORAGE_KEYS.photo);
};
